import React, { ReactNode } from "react";
import { Button } from "antd";
import { Spinner } from "../../spinner";
import "./button.scss";

interface IFormButtonProps {
  className?: string;
  type?:
    | "primary"
    | "link"
    | "text"
    | "ghost"
    | "default"
    | "dashed"
    | undefined;
  theme?: "red" | "green" | "green-light" | "grey" | "white" | "inverted-white";
  htmlType?: "button" | "submit" | "reset" | undefined;
  icon?: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: ReactNode;
}

const baseClass = "button";

export const FormButton = ({
  className = "",
  type = "primary",
  theme = "green",
  htmlType = "button",
  icon,
  disabled = false,
  loading = false,
  onClick,
  onMouseEnter = () => null,
  onMouseLeave = () => null,
  children,
}: IFormButtonProps): JSX.Element => {
  const handleOnClick = (): void => {
    onClick && onClick();
  };

  return (
    <Button
      className={`${baseClass} ${className} ${baseClass}--${theme}`}
      type={type}
      htmlType={htmlType}
      disabled={disabled}
      onClick={handleOnClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {icon && <span className="button-icon">{icon}</span>}
      {children}
      {loading && <Spinner size="small" />}
    </Button>
  );
};
